import React, { useState } from 'react';
import { Button, Card, CardBody } from 'reactstrap';
import { Form, Field } from 'react-final-form';
import CustomInputField from '../../../components/form/CustomInputField';
import Icon from '../../../assets/icons/Icon';
import PasswordChecklist from '../../../components/PasswordChecklist';
import { postChangePassword } from '../src/profileApis';
import { useDict } from '../../../contexts/LanguageContext';
import toast from 'react-hot-toast';

const Security = (props) => {
    const { setIsLoading } = props;

    const dict = useDict();

    const [showOldPassword, setShowOldPassword] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showNewRePassword, setShowNewRePassword] = useState(false);

    const handlePostChangePassword = (response, form) => {
        form.reset();
        form.resetFieldState('current_password');
        form.resetFieldState('new_password');
        form.resetFieldState('new_password_confirmation');

        toast.success(dict.resetPasswordSuccessMessage, {
            duration: 5000,
            id: dict.resetPasswordSuccessMessage,
        });
    };

    const handleSubmit = (values, form) => {
        setIsLoading(true);
        postChangePassword(values, (response) => handlePostChangePassword(response, form));
        setIsLoading(false);
    };

    const showNewRePasswordToggle = (e) => {
        e.preventDefault();
        setShowNewRePassword((prevState) => !prevState);
    };

    const showOldPasswordToggle = (e) => {
        e.preventDefault();
        setShowOldPassword((prevState) => !prevState);
    };

    const showNewPasswordToggle = (e) => {
        e.preventDefault();
        setShowNewPassword((prevState) => !prevState);
    };

    const validate = (values) => {
        const errors = {};

        if (!values.current_password) {
            errors.current_password = dict.oldPasswordEmpty;
        }

        if (!values.new_password) {
            errors.new_password = dict.newPasswordEmpty;
        } else if (
            !/^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.()\-+_={}[\]{};'\\:"|<>?~`])(?=.{8})/.test(
                values.new_password
            )
        ) {
            errors.new_password = dict.passwordInvalid;
        }

        if (!values.new_password_confirmation) {
            errors.new_password_confirmation = dict.rePasswordEmpty;
        } else if (values.new_password_confirmation !== values.new_password) {
            errors.new_password_confirmation = dict.rePasswordNotMatch;
        }

        return errors;
    };

    return (
        <Card className="card_reset_password">
            <CardBody>
                <Form
                    validate={validate}
                    initialValues={{
                        current_password: '',
                        new_password: '',
                        new_password_confirmation: '',
                    }}
                    onSubmit={(values, form) => { handleSubmit(values, form) }}
                >
                    {({ handleSubmit, values }) => (
                        <form className="form" onSubmit={handleSubmit}>
                            <div className="form__form-group">
                                <span className="form__form-group-label security__label">
                                    {dict.oldPassword}
                                </span>
                                <div className="form__form-group-field">
                                    <Field name="current_password">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                type={
                                                    showOldPassword
                                                        ? 'text'
                                                        : 'password'
                                                }
                                                placeholder={dict.enterOldPassword}
                                                input={input}
                                                meta={meta}
                                                data-cy="security__oldPassword"
                                                className='security__input'
                                            />
                                        )}
                                    </Field>
                                    <span
                                        className='form__form-group-button form__form-group-button--show-password'
                                        onClick={showOldPasswordToggle}
                                        role="button"
                                        aria-hidden
                                        tabIndex={0}
                                    >
                                        <Icon
                                            icon={
                                                showOldPassword
                                                    ? 'Eye'
                                                    : 'EyeSlash'
                                            }
                                        />
                                    </span>
                                </div>

                                <span className="form__form-group-label mt-3 security__label">
                                    {dict.newPassword}
                                </span>
                                <div className="form__form-group-field">
                                    <Field name="new_password">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                type={
                                                    showNewPassword
                                                        ? 'text'
                                                        : 'password'
                                                }
                                                placeholder={dict.enterNewPassword}
                                                input={input}
                                                meta={meta}
                                                data-cy="security__newPassword"
                                                className='security__input'
                                            />
                                        )}
                                    </Field>
                                    <span
                                        className='form__form-group-button form__form-group-button--show-password'
                                        onClick={showNewPasswordToggle}
                                        role="button"
                                        aria-hidden
                                        tabIndex={0}
                                    >
                                        <Icon
                                            icon={
                                                showNewPassword
                                                    ? 'Eye'
                                                    : 'EyeSlash'
                                            }
                                        />
                                    </span>
                                </div>

                                <span className="form__form-group-label mt-3 security__label">
                                    {dict.confirmNewPassword}
                                </span>
                                <div className="form__form-group-field">
                                    <Field name="new_password_confirmation">
                                        {({ input, meta }) => (
                                            <CustomInputField
                                                type={
                                                    showNewRePassword
                                                        ? 'text'
                                                        : 'password'
                                                }
                                                placeholder={dict.reenterNewPassword}
                                                input={input}
                                                meta={meta}
                                                data-cy="security__reNewPassword"
                                                className='security__input'
                                            />
                                        )}
                                    </Field>
                                    <span
                                        className='form__form-group-button form__form-group-button--show-password'
                                        onClick={showNewRePasswordToggle}
                                        role="button"
                                        aria-hidden
                                        tabIndex={0}
                                    >
                                        <Icon
                                            icon={
                                                showNewRePassword
                                                    ? 'Eye'
                                                    : 'EyeSlash'
                                            }
                                        />
                                    </span>
                                </div>

                                <div className="form__form-group checklist__div">
                                    <div className="form__form-group-field">
                                        <span className="checklist__span">
                                            <PasswordChecklist
                                                password={
                                                    values?.new_password || ''
                                                }
                                                rePassword={
                                                    values?.new_password_confirmation ||
                                                    ''
                                                }
                                            />
                                        </span>
                                    </div>
                                </div>
                            </div>

                            <div
                                className="account__btns"
                                style={{
                                    marginLeft: '0px',
                                    paddingRight: '12px',
                                }}
                            >
                                <Button
                                    color="primary"
                                    className="btn rounded btn-lg"
                                    type="submit"
                                    style={{
                                        marginLeft: 'auto',
                                        marginRight: 'auto',
                                        display: 'block',
                                    }}
                                    data-cy="security__submitBtn"
                                >
                                    {dict.changePassword}
                                </Button>
                            </div>
                        </form>
                    )}
                </Form>
            </CardBody>
        </Card>
    );
};

export default Security;
